import React from 'react'
import { Grid, List } from 'component/base'

export const TenkoKiroku = ({ data }) => {
  return (
    <Grid>
      <Grid.Row>
        <Grid.Column>
          <List divided relaxed>
            <List.Item>
              <List.Content>
                <List.Header style={{ marginBottom: '0.3em' }}>日付</List.Header>
                {`${data.date}`}
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Content>
                <List.Header style={{ marginBottom: '0.3em' }}>運転者名</List.Header>
                {`${data.driver_name}`}
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Content>
                <List.Header style={{ marginBottom: '0.3em' }}>車両番号</List.Header>
                {`${data.shashu_name +
                ' ' +
                data.rikuun_shikyoku_ryaku_name +
                data.shashu_no +
                data.shashu_no_kana +
                data.toroku_no}`}
              </List.Content>
            </List.Item>
          </List>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}
